<app-layout
    [headerData]="header()"
    [headerData2]="header()"
    [headerData3]="header()"
    [headerData4]="header()"
    [headerData5]="header()"
    [headerData6]="header()"
    [languagesData]="languages()"
    [newsletterData]="newsletter()"
    [modalMultipleMotorsData]="modalMultipleMotors()"
>
    <router-outlet></router-outlet>
</app-layout>
